// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"579":"4c7b68f1","699":"24b80b23","787":"0bad5c2c","926":"ab30bb5f"}[chunkId] + ".chunk.js";
};